import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import Button from '../common/Button';
import Input from '../common/Input';
import Toast from '../common/Toast';

const PaymentInitiation = () => {
  const { tripId } = useParams();
  const [amount, setAmount] = useState('');
  const [toast, setToast] = useState(null);
  const navigate = useNavigate();

  const handlePay = async (e) => {
    e.preventDefault();
    try {
      await api.post('/passenger/pay', { trip_id: tripId, amount });
      setToast({ message: 'Payment initiated. Waiting for mashell approval.', type: 'success' });
      setTimeout(() => navigate('/passenger/trips'), 2000);
    } catch (err) {
      setToast({ message: 'Payment failed', type: 'error' });
    }
  };

  return (
    <div className="glass-card fade-in">
      <h2>Initiate Payment</h2>
      <p>Trip ID: {tripId}</p>
      <form onSubmit={handlePay}>
        <Input label="Amount ($)" type="number" value={amount} onChange={e => setAmount(e.target.value)} required />
        <Button type="submit">Pay Now</Button>
      </form>
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
};
export default PaymentInitiation;